<template>
  <div :class="$style.page">
    <Title title="账户信息" mode="margin" />

    <Row>
      <div :class="$style.info">
        可用金额：
        <span :class="$style.balance">{{
          amountInfo.restAmount ? amountInfo.restAmount : "0"
        }}</span>
        元
      </div>

      <Button type="primary" round @click="toRecharge">充值</Button>
      <Button type="blue" round @click="toWithdrawal">提现</Button>
    </Row>

    <Row>
      <div :class="$style.info">
        返现金额：
        <span :class="$style.freeze">{{
          amountInfo.rebate ? amountInfo.rebate : "0"
        }}</span>
        元
      </div>
    </Row>

    <Row>
      <div :class="$style.info">
        冻结金额：
        <span :class="$style.freeze">{{
          amountInfo.freezeAmount ? amountInfo.freezeAmount : "0"
        }}</span>
        元
      </div>
    </Row>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Account",
  data() {
    return {
      balance: "0.00",
    };
  },
  computed: {
    ...mapState("user", ["amountInfo"]),
  },
  methods: {
    toRecharge() {
      this.$router.push("/user/recharge");
    },
    toWithdrawal() {
      this.$router.push("/user/withDrawal");
    },
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: 300px;
  padding: rem(50);
  font-size: rem(16);
  color: #333;
  background: $white;
  box-shadow: $box-shadow;

  .info {
    font-size: 14px;
    color: #333;
    line-height: 36px;
    margin-right: 64px;
  }

  .balance {
    color: $theme-color;
    font-weight: bold;
  }

  .freeze {
    color: #000;
    font-weight: bold;
  }

  :global {
    .gl-button {
      margin-right: rem(30);
    }
  }
}
</style>
